import { gql } from '@apollo/client'

const BASE_RECOMMENDED_ARTICLE_FIELDS = gql`
  fragment BaseRecommendedArticleFields on RecommendedArticleType {
    id
    name
    description
    link
    order
    membershipLevel
    recommendedArticleGroup {
      id
      color
      title
    }
  }
`

export const FIND_ALL_RECOMMENDED_ARTICLES = gql`
  ${BASE_RECOMMENDED_ARTICLE_FIELDS}
  query findAllRecommendedArticle($query: RecommendedArticleQueryInput!) {
    findAllRecommendedArticle(query: $query) {
      count
      items {
        createdAt
        ...BaseRecommendedArticleFields
      }
    }
  }
`

export const CREATE_RECOMMENDED_ARTICLE = gql`
  mutation createRecommendedArticle($params: CreateRecommendedArticleInput!) {
    createRecommendedArticle(createRecommendedArticleInput: $params) {
      id
    }
  }
`

export const UPDATE_RECOMMENDED_ARTICLE = gql`
  mutation UpdateRecommendedArticle($params: UpdateRecommendedArticleInput!) {
    updateRecommendedArticle(updateRecommendedArticleInputFieldName: $params) {
      id
    }
  }
`

export const DELETE_RECOMMENDED_ARTICLE = gql`
  mutation removeRecommendedArticle($removeRecommendedArticleId: String!) {
    removeRecommendedArticle(id: $removeRecommendedArticleId) {
      affected
    }
  }
`

export const BULK_UPDATE_RECOMMENDED_ARTICLE = gql`
  mutation bulkUpdateRecommendedArticle($bulkUpdateRecommendedArticleInput: [BulkUpdateRecommendedArticleInput!]!) {
    bulkUpdateRecommendedArticle(bulkUpdateRecommendedArticleInput: $bulkUpdateRecommendedArticleInput) {
      id
    }
  }
`

export const BULK_REMOVE_RECOMMENDED_ARTICLES = gql`
  mutation bulkRemoveRecommendedArticle($ids: [LinkRecommendedArticleInput!]!) {
    bulkRemoveRecommendedArticle(ids: $ids) {
      affected
    }
  }
`
